export const selectUsername = ({ authentication }) => authentication.username;
export const selectPassword = ({ authentication }) => authentication.password;
export const selectPasswordReset = ({ authentication }) => authentication.passwordReset;
export const selectClientName = ({ authentication }) => authentication.client_name;
export const selectClient = ({ authentication }) => authentication.client;
export const selectReturningUser = ({ authentication }) => authentication.selectReturningUser;



// WEBPACK FOOTER //
// ./src/core/auth/selectors.js